export const WIDGET_LINK_CLICK = "Widget: Link Click";
